const TeamIcon = ({ color }: any) => {
  return (
    <svg width={22} height={22} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.583 19.25v-1.833a3.667 3.667 0 00-3.667-3.667H4.583a3.667 3.667 0 00-3.667 3.667v1.833M8.25 10.083a3.667 3.667 0 100-7.333 3.667 3.667 0 000 7.333zM21.084 19.25v-1.833a3.666 3.666 0 00-2.75-3.548M14.666 2.87a3.667 3.667 0 010 7.103'
        strokeWidth={1.75}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default TeamIcon
